export default {
  FETCH_TOOLS_REQUEST: 'FETCH_TOOLS_REQUEST',
  FETCH_TOOLS_SUCCESS: 'FETCH_TOOLS_SUCCESS',
  FETCH_TOOLS_FAILURE: 'FETCH_TOOLS_FAILURE',
  FETCH_ALL_TOOLS_REQUEST: 'FETCH_ALL_TOOLS_REQUEST',
  FETCH_ALL_TOOLS_SUCCESS: 'FETCH_ALL_TOOLS_SUCCESS',
  FETCH_ALL_TOOLS_FAILURE: 'FETCH_ALL_TOOLS_FAILURE',
  RESET_TOOLS: 'RESET_TOOLS'
}
